import '@formatjs/intl-locale/polyfill';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { I18nContext } from './I18nContext';
const RTL_SCRIPTS = new Set([
    'Adlm',
    'Arab',
    'Hebr',
    'Mand',
    'Mend',
    'Nkoo',
    'Rohg',
    'Samr',
    'Syrc',
    'Thaa',
]);
const isRTL = (languageCode) => {
    const { script } = new Intl.Locale(languageCode).maximize();
    if (!script) {
        return false;
    }
    return RTL_SCRIPTS.has(script);
};
/** Returns an object containing the session's current language code, its writing direction, and a function to change the language code. */
const useLocale = () => {
    const context = useContext(I18nContext);
    if (!context) {
        throw new Error('`useLocale` must be used within a <I18nContext.Provider />');
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    /* @ts-ignore */
    const { i18n } = useTranslation(undefined, {
        useSuspense: false,
        i18n: context,
    });
    return {
        languageCode: i18n.language,
        setLanguageCode: (lang) => {
            return new Promise((resolve, reject) => {
                i18n.changeLanguage(lang, (err) => {
                    if (err) {
                        reject(err);
                        return;
                    }
                    resolve();
                });
            });
        },
        writingDirection: isRTL(i18n.language) ? 'rtl' : 'ltr',
    };
};
export { useLocale };
//# sourceMappingURL=useLocale.js.map